module.exports = __webpack_public_path__ + "image/wx_ewm.jpg";